import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const OpenAdmissionsFormMutation = graphql.persisted(
  "OpenAdmissionsForm",
  graphql(`
    mutation OpenAdmissionsForm($token: String!) {
      openAdmissionsForm(input: { token: $token }) {
        familyEnrollment { id }
        formMetadata
        formAnswers
        schema
        schemaHints { path schemaKey entityIdPath }
        tuitionOptions
        paymentOptions
        enrollmentFee
        gradeLevels
        schoolYearName
        schoolName
        familyName
        userErrors { message path }
      }
    }
  `)
);

export { OpenAdmissionsFormMutation };

export function useOpenAdmissionsForm() {
  return useMutation(OpenAdmissionsFormMutation);
}
